import React from 'react';
import { CONSTANTS } from '../../data';
import { ASSETS } from '../../assetManifest';
import { sounds } from '../../systems/AudioSystem';
import type { AssetsSchema } from '../../assetManifestTypes';

interface GameOverScreenProps {
  onBack: () => void;
}

export const GameOverScreen: React.FC<GameOverScreenProps> = ({ onBack }) => {
  const typedAssets = ASSETS as AssetsSchema;
  const backgroundAsset = typedAssets.backgrounds?.main_menu_neural_network;

  return (
    <div
      className="menu-screen"
      style={{
        backgroundImage: backgroundAsset ? `url(${backgroundAsset.path})` : undefined,
      }}
    >
      <div className="menu-screen-content">
        <h2>{CONSTANTS.GAME_OVER_SCREEN.title}</h2>
        <p>{CONSTANTS.GAME_OVER_SCREEN.content}</p>
      </div>
      <button 
        className="menu-button mt-8" 
        onClick={() => {
          sounds.buttonClick();
          onBack();
        }}
        onMouseEnter={() => sounds.menuHover()}
      >
        {CONSTANTS.GAME_OVER_SCREEN.buttonText}
      </button>
    </div>
  );
};
